import React, { useCallback, useEffect, useState } from "react";
import { Card, Grid, Image, Header, Button, Icon, Divider } from "semantic-ui-react";
import PackageSelector, { PackageItem } from "./PackageSelector";
import CONFIG from "config/config";
import MeHealthHistoryModal from "./MeHealthHistoryModal";
import "react-lib/apps/MEH/CardBuyBillingPackage.scss";
import { formatISOToThaiDate } from "react-lib/utils/dateUtils";

type CardBuyBillingPackageProps = {
  BillingAndPackageSequence: any;
  BillingCreditWallet: any;
  BillingCarts: any;
  onHistoryClick?: () => void;
  controller: any;
  runSequence: any;
  onEvent: any;
  setProp: any;
  languageUX: any;
  onProceed?: () => void;
  termsAndConditionsList?: any;
};

const HOSPITAL_IMAGE_URL = `${process.env.PUBLIC_URL}/static/images/hospital.png`;
const TITLE = "MeHealth Credit"
const BALANCE_LABEL = "ยอดคงเหลือ"
const HISTORY_LABEL = "ประวัติการทำรายการ"

const CardBuyBillingPackage = (props: CardBuyBillingPackageProps) => {
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [editorContent, setEditorContent] = useState("");
  const creditBalance = props.BillingCreditWallet?.balance ?? 0;
  const creditUpdatedAt = props.BillingCreditWallet?.balance_updated_at;

  useEffect(() => {
    // TODO: need check runsequnce
    props.runSequence({ sequence: "BillingAndPackage", restart: true });
    return () => {
      props.runSequence({ sequence: "BillingAndPackage", clear: true });
    };
  }, [props.controller.division]);

  useEffect(() => {
    props.onEvent({
      message: "HandleGetTermsAndConditionsList",
    });
  }, []);

  useEffect(() => {
    if (props.termsAndConditionsList?.length) {
      const publishedTerms = props.termsAndConditionsList.filter(
        (t: any) => t.status === "PUBLISHED"
      );
      const latestPublished = publishedTerms.sort(
        (a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime()
      )[0];

      if (latestPublished?.content) {
        setEditorContent(latestPublished.content);
      } else {
        setEditorContent("");
      }
    } else {
      setEditorContent("");
    }
  }, [props.termsAndConditionsList]);

  return (
    <div id="CardBuyBillingPackage" style={{ padding: "6px" }}>
      <Card fluid style={{ borderRadius: 14 }}>
        <Card.Content>
          <Grid stackable verticalAlign="middle" columns={2} divided>
            {/* Left: clinic block */}
            <Grid.Column width={6}>
              <div style={{ display: "flex", gap: 14 }}>
                <Image
                  circular
                  src={
                    props.BillingAndPackageSequence?.divisionProfile?.image_file ||
                    HOSPITAL_IMAGE_URL
                  }
                  alt={props.BillingAndPackageSequence?.divisionProfile?.division_name}
                  rounded
                  style={{ width: 92, height: 92, objectFit: "cover", flexShrink: 0 }}
                />
                <div style={{ lineHeight: 1.4 }}>
                  <Header as="h4" style={{ marginBottom: 6 }}>
                    {props.BillingAndPackageSequence?.divisionProfile?.division_name}
                  </Header>
                  <div style={{ color: "rgba(0,0,0,.6)", whiteSpace: "pre-wrap" }}>
                    <b>สถานที่ตั้ง :</b>{" "}
                    {props.BillingAndPackageSequence?.divisionProfile?.address_text}
                  </div>

                  <div style={{ color: "rgba(0,0,0,.6)" }}>
                    <b>เลขที่ประจำตัวผู้เสียภาษี :</b>{" "}
                    {props.BillingAndPackageSequence?.divisionProfile?.tax_payer_id ?? ""}
                  </div>

                </div>
              </div>
            </Grid.Column>

            {/* Right: credit block */}
            <Grid.Column width={10}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 2fr auto",
                  gap: 6,
                  alignItems: "center",
                }}
              >
                <Header as="h4" style={{ color: "#e91e63", margin: 0 }}>
                  {TITLE}
                </Header>
                <div />
                <div />
                <div>
                  <div style={{ fontWeight: 700 }}>{BALANCE_LABEL}</div>
                  {creditUpdatedAt && (
                    <div style={{ color: "rgba(0,0,0,.6)" }}>{formatISOToThaiDate(creditUpdatedAt)}</div>
                  )}
                </div>
                <Header as="h2" style={{ margin: 0 }}>
                  {Number(creditBalance).toLocaleString(undefined, { minimumFractionDigits: 2 })} Credit
                </Header>
                <div style={{ justifySelf: "end" }}>
                  <Button color="pink" size="small" onClick={() => setOpenHistoryModal(true)}>
                    <Icon name="history" />
                    {HISTORY_LABEL}
                  </Button>
                </div>
              </div>
            </Grid.Column>
          </Grid>
        </Card.Content>
      </Card>
      <div style={{ marginTop: 16 }}>
        <PackageSelector
          languageUX={props.languageUX}
          runSequence={props.runSequence}
          meHealthPackageList={props.BillingAndPackageSequence?.meHealthPackageList}
          BillingCarts={props.BillingCarts}
          onProceed={props.onProceed}
        />
      </div>
      <div style={{ marginTop: 30 }}>
        <div style={{ color: "rgba(0,0,0,.6)", fontSize: 15, lineHeight: 1.8, marginLeft: "1rem" }}>
          <div
            className="editor-content"
            dangerouslySetInnerHTML={{ __html: editorContent }}
          />
        </div>
      </div>
      <MeHealthHistoryModal
        open={openHistoryModal}
        onClose={() => setOpenHistoryModal(false)}
        BillingAndPackageSequence={props.BillingAndPackageSequence}
        BillingCreditWallet={props.BillingCreditWallet}
        runSequence={props.runSequence}
        setProp={props.setProp}
      />
    </div>
  );
};

export default CardBuyBillingPackage;
